<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="data-list-list-view" class="data-list-container">
		<vs-popup class="holamundo" :title="$t('Status.CreateStatus')" :active.sync="createStatusModal">
			<div class="p-2 py-0">
				<StatusForm :isEditActive="false" :hideModal="hideCreateModal" />
			</div>
		</vs-popup>

		<status-view-sidebar
			:isSidebarActive="addNewDataSidebar"
			@closeSidebar="toggleDataSidebar"
			:data="sidebarData"
		/>
		<vx-card>
			<div class="flex flex-wrap-reverse items-center flex-grow justify-between">
				<div class="flex flex-wrap-reverse items-center data-list-btn-container mt-3">
					<!-- ADD NEW -->
					<div
						v-if="statusCreatePermission"
						class="btn-add-new p-3 mb-4 mr-4 ml-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
						@click="createStatusModal = true"
					>
						<feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
						<span class="ml-2 text-base text-primary">{{ $t("Status.AddNew") }}</span>
					</div>
				</div>
			</div>

			<div v-if="statusReadPermission">
				<vs-table
					v-if="listStatus != undefined"
					id="div-with-loading"
					ref="table"
					multiple
					v-model="selected"
					@selected="handleSelected"
					pagination
					:max-items="itemsPerPage"
					search
					:data="listStatus"
				>
					<div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
						<div class="flex flex-wrap-reverse items-center data-list-btn-container"></div>

						<!-- ITEMS PER PAGE -->
						<vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
							<div
								class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
							>
								<span class="mr-2"
									>{{ currentPage * itemsPerPage - (itemsPerPage - 1) }}
									-
									{{
										listStatus.length - currentPage * itemsPerPage > 0
											? currentPage * itemsPerPage
											: listStatus.length
									}}
									{{ $t("Of") }} {{ queriedItems }}</span
								>
								<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
							</div>
							<vs-dropdown-menu>
								<vs-dropdown-item @click="itemsPerPage = 4">
									<span>4</span>
								</vs-dropdown-item>
								<vs-dropdown-item @click="itemsPerPage = 10">
									<span>10</span>
								</vs-dropdown-item>
								<vs-dropdown-item @click="itemsPerPage = 15">
									<span>15</span>
								</vs-dropdown-item>
								<vs-dropdown-item @click="itemsPerPage = 20">
									<span>20</span>
								</vs-dropdown-item>
							</vs-dropdown-menu>
						</vs-dropdown>
					</div>

					<template slot="thead">
						<vs-th sort-key="name">{{ $t("BreakTable.Name") }}</vs-th>
						<vs-th v-if="statusUpdatePermission || statusDeletePermission">{{
							$t("BreakTable.Action")
						}}</vs-th>
					</template>

					<template slot-scope="{data}">
						<tbody>
							<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
								<vs-td>
									<p class="product-name font-medium truncate capitalize">
										{{ tr.name }}
									</p>
								</vs-td>
								<vs-td
									class="whitespace-no-wrap"
									v-if="statusUpdatePermission || statusDeletePermission"
								>
									<feather-icon
										v-if="statusUpdatePermission"
										icon="EditIcon"
										svgClasses="w-5 h-5 hover:text-primary stroke-current"
										@click.stop="editData(tr)"
									/>
									<feather-icon
										v-if="statusDeletePermission"
										icon="TrashIcon"
										svgClasses="w-5 h-5 hover:text-danger stroke-current"
										class="ml-2"
										@click.stop="openConfirm(tr.id)"
									/>
								</vs-td>
							</vs-tr>
						</tbody>
					</template>
				</vs-table>
			</div>

			<not-permission v-else></not-permission>
		</vx-card>
	</div>
</template>

<script>
import StatusViewSidebar from "./StatusSidebar.vue";
import moduleStatus from "@/store/status/moduleStatus.js";
import StatusForm from "@/components/status/StatusForm.vue";
import NotPermission from "@/views/pages/NotPermission.vue";

export default {
	name: "SkillsListView",
	components: {
		StatusViewSidebar,
		StatusForm,
		NotPermission,
	},
	data() {
		return {
			selected: [],
			itemsPerPage: 10,
			isMounted: false,
			itemSelected: null,
			// Data Sidebar
			addNewDataSidebar: false,
			sidebarData: {},
			createStatusModal: false,
			//companies:[]
		};
	},
	computed: {
		currentPage() {
			if (this.isMounted) {
				if (this.$refs.table) return this.$refs.table.currentx;
			}
			return 0;
		},
		listStatus() {
			return this.$store.state.moduleStatus.status;
		},
		queriedItems() {
			return this.$refs.table ? this.$refs.table.queriedResults.length : this.listStatus.length;
		},
		totalbreaksList() {
			return this.$store.getters["moduleStatus/totalStatus"];
		},
		statusCreatePermission() {
			return this.$store.getters.checkPermission("STATUS_C");
		},
		statusReadPermission() {
			return this.$store.getters.checkPermission("STATUS_R");
		},
		statusUpdatePermission() {
			return this.$store.getters.checkPermission("STATUS_U");
		},
		statusDeletePermission() {
			return this.$store.getters.checkPermission("STATUS_D");
		},
	},
	methods: {
		print() {},
		handleSelected(tr) {},
		hideCreateModal() {
			this.createStatusModal = false;
		},
		addNewData() {
			this.$router.push("/dashboard/new-status");
		},
		openConfirm(id) {
			this.itemSelected = id;
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text: this.$t("Status.Messages.TextDelete"),
				accept: this.acceptAlert,
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
			});
		},
		acceptAlert() {
			this.deleteData(this.itemSelected);
		},
		deleteData(id) {
			this.$store
				.dispatch("moduleStatus/removeItem", id)
				.then((res) => {
					this.$vs.notify({
						color: "success",
						title: this.$t("Status.Messages.TitleConfirmDelete"),
						text: this.$t("Status.Messages.TextConfirmDelete"),
					});
				})
				.catch((err) => {
					console.error(err);
				});
		},
		editData(data) {
			this.sidebarData = data;
			this.toggleDataSidebar(true);
		},
		getOrderStatusColor(status) {
			if (status === "on_hold") return "warning";
			if (status === "delivered") return "success";
			if (status === "canceled") return "danger";
			return "primary";
		},
		getPopularityColor(num) {
			if (num > 90) return "success";
			if (num > 70) return "primary";
			if (num >= 50) return "warning";
			if (num < 50) return "danger";
			return "primary";
		},
		toggleDataSidebar(val = false) {
			this.addNewDataSidebar = val;
		},
	},
	created() {
		if (!moduleStatus.isRegistered) {
			this.$store.registerModule("moduleStatus", moduleStatus);
			moduleStatus.isRegistered = true;
		}
		this.$store.dispatch("moduleStatus/fetchDataListItems").then(() => {
			this.$vs.loading.close();
		});
	},
	mounted() {
		this.isMounted = true;
		this.$vs.loading();
	},
};
</script>

<style lang="scss">
#data-list-list-view {
	.vs-con-table {
		/*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
		@media (max-width: 689px) {
			.vs-table--search {
				margin-left: 0;
				max-width: unset;
				width: 100%;

				.vs-table--search-input {
					width: 100%;
				}
			}
		}

		@media (max-width: 461px) {
			.items-per-page-handler {
				display: none;
			}
		}

		@media (max-width: 341px) {
			.data-list-btn-container {
				width: 100%;

				.dd-actions,
				.btn-add-new {
					width: 100%;
					margin-right: 0 !important;
				}
			}
		}

		.product-name {
			max-width: 23rem;
		}

		.vs-table--header {
			display: flex;
			flex-wrap: wrap;
			margin-left: 1.5rem;
			margin-right: 1.5rem;
			> span {
				display: flex;
				flex-grow: 1;
			}

			.vs-table--search {
				padding-top: 0;

				.vs-table--search-input {
					padding: 0.9rem 2.5rem;
					font-size: 1rem;

					& + i {
						left: 1rem;
					}

					&:focus + i {
						left: 1rem;
					}
				}
			}
		}

		.vs-table {
			border-collapse: separate;
			border-spacing: 0 1.3rem;
			padding: 0 1rem;

			tr {
				box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
				td {
					padding: 20px;
					&:first-child {
						border-top-left-radius: 0.5rem;
						border-bottom-left-radius: 0.5rem;
					}
					&:last-child {
						border-top-right-radius: 0.5rem;
						border-bottom-right-radius: 0.5rem;
					}
				}
				td.td-check {
					padding: 20px !important;
				}
			}
		}

		.vs-table--thead {
			th {
				padding-top: 0;
				padding-bottom: 0;

				.vs-table-text {
					text-transform: uppercase;
					font-weight: 600;
				}
			}
			th.td-check {
				padding: 0 15px !important;
			}
			tr {
				background: none;
				box-shadow: none;
			}
		}

		.vs-table--pagination {
			justify-content: center;
		}
	}
}
</style>
